import { VpChevronUpIcon } from '@vtmn-play/icons/react'
import { VpIconButton } from '@vtmn-play/react/headless'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './back-to-top-button.scss'

const VIEWPORT_THRESHOLD = 2

export function BackToTopButton() {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(() => window.scrollY > window.innerHeight * VIEWPORT_THRESHOLD)

  useEffect(() => {
    const updateVisibility = () => {
      setIsVisible(window.scrollY > window.innerHeight * VIEWPORT_THRESHOLD)
    }

    window.addEventListener('scroll', updateVisibility, { passive: true })
    window.addEventListener('resize', updateVisibility)

    return () => {
      window.removeEventListener('scroll', updateVisibility)
      window.removeEventListener('resize', updateVisibility)
    }
  }, [])

  const scrollToTop = () => {
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'instant' : 'smooth',
    })
  }

  return (
    <VpIconButton
      aria-label={t('aria-label.back-to-top')}
      aria-hidden={!isVisible}
      className={clsx('back-to-top-button', { visible: isVisible })}
      onClick={scrollToTop}
      tabIndex={isVisible ? undefined : -1}
      variant="ghost"
    >
      <VpChevronUpIcon aria-hidden="true" />
    </VpIconButton>
  )
}
